import { useState, useEffect, useRef } from 'react';

const API = window.location.origin;
const PAGE_SIZE = 100;

export function useThemePoems(themeId) {
  const [poems, setPoems]             = useState(null); // null = loading
  const [total, setTotal]             = useState(null);
  const [error, setError]             = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const loadingMoreRef                = useRef(false);

  useEffect(() => {
    const ctrl = new AbortController();
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setError(false);
    setPoems(null);
    setTotal(null);
    fetch(
      `${API}/api/poems/browse?theme=${encodeURIComponent(themeId)}&limit=${PAGE_SIZE}&offset=0`,
      { signal: ctrl.signal }
    )
      .then(r => { if (!r.ok) throw new Error('non-ok'); return r.json(); })
      .then(data => {
        const list = data.poems ?? [];
        setTotal(data.total ?? list.length);
        setPoems(list);
      })
      .catch(err => { if (err.name !== 'AbortError') { setError(true); setPoems([]); } });
    return () => ctrl.abort();
  }, [themeId]);

  async function loadMore() {
    // Guard: already loading, no poems loaded yet, or all poems already fetched
    if (loadingMoreRef.current || !poems || (total !== null && poems.length >= total)) return;
    loadingMoreRef.current = true;
    setLoadingMore(true);
    const offset = poems.length;
    try {
      const r = await fetch(
        `${API}/api/poems/browse?theme=${encodeURIComponent(themeId)}&limit=${PAGE_SIZE}&offset=${offset}`
      );
      if (!r.ok) throw new Error('non-ok');
      const data = await r.json();
      // Validate offset hasn't changed (concurrent call guard)
      setPoems(prev => {
        if (!prev || prev.length !== offset) return prev;
        return [...prev, ...(data.poems ?? [])];
      });
      setTotal(data.total ?? total);
    } catch {
      // non-critical — user can retry
    } finally {
      loadingMoreRef.current = false;
      setLoadingMore(false);
    }
  }

  return { poems, total, error, loadingMore, loadMore };
}
